import ResourceBody from './components/ResourceBody';
import ResourceHeading from './components/ResourceHeading';

export {
  ResourceBody,
  ResourceHeading,
};
